/* eslint-disable @typescript-eslint/no-explicit-any */
import createImmutableSelector from 'lib/immutable/selector'
import { IPersist } from './../models'
import { Selector } from 'reselect'

// TODO: pass Store type
const getPersist = (state: any) => state.get('_persist')

export const getRehydrateSelector: Selector<any, IPersist> = createImmutableSelector(getPersist, (persist) =>
  persist.get('rehidrated')
)

export default getRehydrateSelector
